import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { config } from "../../services/configHeader";
const user = JSON.parse(localStorage.getItem("user_data")) || {}
// const userId = user?.user_id;
const accountType = user?.account_type;
const baseUrl = process.env.REACT_APP_BASE_URI;

let initialState = {
    leaveLoading: false,
    leaveSuccess: false,
    leaveError: false,
    leaveMessage: null,

    leaveGetLoading: false,
    leaveGetSuccess: false,
    leaveGetError: false,
    leaveGetMessage: null,
    leaveGetData: null,

    fetchLeaveLoading: false,
    fetchLeaveSuccess: false,
    fetchLeaveError: false,
    fetchLeaveMessage: null,
    fetchLeaveData: null,
};

export const fetchLeave = createAsyncThunk("fetchLeave", async (path) => {
    return await axios
        .get(`${baseUrl}${path}`, config)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            if (!navigator.onLine) {
                let data = {
                    response: {
                        data: [],
                        message: "No Internet Connection Found",
                        success: false,
                    },
                    data: {
                        data: [],
                        message: "No Internet Connection Found",
                        success: false,
                    },
                };
                return data;
            } else {
                return error;
            }
        });
});

export const fetchLeaveData = createAsyncThunk("fetchLeaveData", async (path) => {
    return await axios
        .get(`${baseUrl}${path}`, config)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            if (!navigator.onLine) {
                let data = {
                    response: {
                        data: [],
                        message: "No Internet Connection Found",
                        success: false,
                    },
                    data: {
                        data: [],
                        message: "No Internet Connection Found",
                        success: false,
                    },
                };
                return data;
            } else {
                return error;
            }
        });
});

export const saveLeave = createAsyncThunk("saveLeave", async (data) => {
    const result = {
        data: {
            message: "Sorry, you can only view the data, not create it.",
            data: [],
        },
    };
    return parseInt(accountType) === 2
        ? result
        : await axios
            .post(`${baseUrl}admin/createMyHoliday`, data, config)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                if (!navigator.onLine) {
                    let data = {
                        response: {
                            data: [],
                            message: "No Internet Connection Found",
                            success: false,
                        },
                        data: {
                            data: [],
                            message: "No Internet Connection Found",
                            success: false,
                        },
                    };
                    return data;
                } else {
                    return error;
                }
            });
});

const leaveSlice = createSlice({
    name: "leave",
    initialState,

    reducers: {

        initFetchLeaveState: (state) => {
            state.fetchLeaveLoading = false;
            state.fetchLeaveSuccess = false;
            state.fetchLeaveError = false;
            state.fetchLeaveMessage = null;
            state.fetchLeaveData = null;
        }

    },

    extraReducers: (builder) => {
        builder.addCase(fetchLeave.pending, (state, action) => {
            state.leaveGetLoading = true;
            state.leaveGetSuccess = false;
            state.leaveGetError = false;
            state.leaveGetMessage = null;
            state.leaveGetData = null;
        });
        builder.addCase(fetchLeave.fulfilled, (state, action) => {
            state.leaveGetLoading = false;
            state.leaveGetSuccess = true;
            state.leaveGetError = false;
            state.leaveGetMessage = action.payload.status == 200 ? action.payload.data.message : action.payload.response.data.message;
            state.leaveGetData = action.payload.status == 200 ? action.payload.data.data : [];
        });
        builder.addCase(fetchLeave.rejected, (state, action) => {
            state.leaveGetLoading = false;
            state.leaveGetSuccess = false;
            state.leaveGetError = true;
            state.leaveGetMessage = action.payload.data.message;
            state.leaveGetData = null;
        });
        // To create holiday ------------------------------------
        builder.addCase(saveLeave.pending, (state, action) => {
            state.leaveLoading = true;
            state.leaveSuccess = false;
            state.leaveError = false;
            state.leaveMessage = null;
        });
        builder.addCase(saveLeave.fulfilled, (state, action) => {
            state.leaveLoading = false;
            state.leaveSuccess = accountType == 2 ? false : true;
            state.leaveError = accountType == 2 ? true : false;
            state.leaveMessage = action.payload.data.message;
        });
        builder.addCase(saveLeave.rejected, (state, action) => {
            state.leaveLoading = false;
            state.leaveSuccess = false;
            state.leaveError = true;
            state.leaveMessage = action.payload.data.message;
        });
        // ----------------------------------------------------------
        // -----------------------------------------

        builder.addCase(fetchLeaveData.pending, (state, action) => {
            state.fetchLeaveLoading = true;
            state.fetchLeaveSuccess = false;
            state.fetchLeaveError = false;
            state.fetchLeaveMessage = null;
            state.fetchLeaveData = null;
        });

        builder.addCase(fetchLeaveData.fulfilled, (state, action) => {
            const status = action.payload.status;
            if (status == 200 || status == "200") {
                if (
                    action.payload.data.status == true ||
                    action.payload.data.status == "true"
                ) {
                    state.fetchLeaveLoading = false;
                    state.fetchLeaveSuccess = true;
                    state.fetchLeaveError = false;
                    state.fetchLeaveMessage = action.payload.data.message;
                    state.fetchLeaveData = action.payload.data.data;
                } else {
                    state.fetchLeaveLoading = false;
                    state.fetchLeaveSuccess = false;
                    state.fetchLeaveError = true;
                    state.fetchLeaveMessage = action.payload.data.message
                        ? action.payload.data.message
                        : action.payload.data.msg;
                    state.fetchLeaveData = null;
                }
            } else {
                state.fetchLeaveLoading = false;
                state.fetchLeaveSuccess = false;
                state.fetchLeaveError = true;
                state.fetchLeaveMessage = action.payload.response.data.message;
                state.fetchLeaveData = action.payload.response.data.data;
            }
        });

        builder.addCase(fetchLeaveData.rejected, (state, action) => {
            state.fetchLeaveLoading = false;
            state.fetchLeaveSuccess = true;
            state.fetchLeaveError = false;
            state.fetchLeaveMessage = null;
            state.fetchLeaveData = null;
        });
    },
});
export const { initFetchLeaveState } = leaveSlice.actions;

export default leaveSlice.reducer;
